module.exports = __webpack_public_path__ + "static/media/bike2b.daf0f0b1.jpg";